/*
 * @Author: your name
 * @Date: 2021-01-05 15:18:26
 * @LastEditTime: 2021-01-05 17:56:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\SingleView.js
 * // 交互：回退上帝视角、上帝视角进单场景、场景间切换(view.js中)
 */
import * as THREE from 'three'
import { config } from './config'

export class SingleView {
  /**
   * 构造函数
   * @param {Scene} scene scene实例
   * @param {Model} model 模型实例
   */
  constructor (scene, model) {
    /**
     * @type {Scene} scene 实例
     */
    this.scene = scene
    /**
     * @type {THREE.Scene} 场景根节点
     */
    this.savedScene = scene.scene
    /**
     * @type {Model} 模型实例
     */
    this.model = model
    /**
     * @type {[]} 模型子组件列表
     */
    this.savedObjects = this.model.objects // 用于射线检测的objects

    /**
     * @type {THREE.Scene} 单场景
     */
    this.scene2 = null // THREE.Scene
    /**
     * @type {THREE.Mesh} 单场景内的天空盒
     */
    this.cube2 = null // THREE.Mesh

    /**
     * @type {boolean} 是否处于单场景中
     */
    this.nowSingle = false
  }

  /**
   * 初始化单场景2
   */
  initScene2 () {
    this.scene2 = new THREE.Scene()
    this.scene2.background = new THREE.Color(0x222222)
    // create
    this.cube2 = this.model.cube.clone()
    this.cube2.position.copy(config.SingleView.CameraPosition) // 很远的地方
    this.scene2.add(this.cube2)
  }

  /**
   * 进入单场景
   */
  enterSingleView () {
    // 交换scene场景，更改scene
    this.scene.scene = this.scene2
    // todo 模型objects暂时交换，防止触发raycast
    this.model.objects = []
    this.nowSingle = true
  }

  /**
   * 离开单场景
   */
  exitSingleView () {
    this.scene.scene = this.savedScene
    this.model.objects = this.savedObjects
    this.nowSingle = false
  }

  /**
   * 销毁，资源释放
   */
  depose () {
    // TODO：销毁场景2
  }
}
